import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// export default function MobileConnectQR() {
//   const waiterURL = "https://superbills.pages.dev/#/tables?waiter=true";

//   return (
//     <div style={{ textAlign: 'center', marginTop: 30 }}>
//       <h3>📱 Connect Waiter App</h3>
//       <p>Scan this QR to open the waiter panel</p>
//       <QRCodeCanvas value={waiterURL} size={200} />
//       <p>{waiterURL}</p>
//     </div>
//   );
// }


export default function MobileConnectQR() {
  const waiterURL = "https://superbills.pages.dev/#/tables?waiter=true";

  return (
    <div className="flex flex-col items-center mt-8">
      <h3 className="text-lg font-semibold mb-2">📱 Connect Waiter App</h3>
      <p className="text-sm mb-4 text-center">Scan this QR to open the waiter panel</p>
      <QRCodeCanvas value={waiterURL} size={200} />
      <p className="text-xs mt-2 break-all text-center">{waiterURL}</p>
    </div>
  );
}
